import * as React from "react";

import { Checkbox } from "@/components/ui/checkbox";

export interface ShiftCheckboxChangeMeta {
  shiftKey: boolean;
}

interface Props extends Omit<React.ComponentPropsWithoutRef<typeof Checkbox>, "checked" | "onCheckedChange"> {
  checked: boolean;
  onCheckedChange: (checked: boolean, meta: ShiftCheckboxChangeMeta) => void;
}

export const ShiftCheckbox: React.FC<Props> = ({ checked, onCheckedChange, onPointerDown, onKeyDown, ...props }) => {
  const changeMetaRef = React.useRef<ShiftCheckboxChangeMeta>({ shiftKey: false });

  const handlePointerDown = (event: React.PointerEvent<HTMLButtonElement>) => {
    changeMetaRef.current = { shiftKey: event.shiftKey };
    onPointerDown?.(event);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>) => {
    if (event.key === " " || event.key === "Enter") {
      changeMetaRef.current = { shiftKey: event.shiftKey };
    }
    onKeyDown?.(event);
  };

  const handleCheckedChange = (nextChecked: boolean | "indeterminate") => {
    onCheckedChange(nextChecked === true, changeMetaRef.current);
    changeMetaRef.current = { shiftKey: false };
  };

  return (
    <Checkbox
      {...props}
      checked={checked}
      onCheckedChange={handleCheckedChange}
      onPointerDown={handlePointerDown}
      onKeyDown={handleKeyDown}
    />
  );
};
